/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const ValueContainer = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.ValueContainer;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

ValueContainer.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      ValueContainer: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

ValueContainer.defaultProps = {
  selectProps: {
    custom: {
      ValueContainer: null,
    },
  },
  children: null,
};

export default ValueContainer;
